<template>
    <div>
         <div class="history">
                            <div class="d-flex align-items-center justify-content-between">
                                <h1>Other offerings on the same CUSIP</h1>
                                    <!-- <div class="action">
                                        <a href="#"><i class="fa fa-cog"></i></a>
                                        <a href="#" class="mx-3"><i class="fa fa-expand"></i></a>
                                        <a href="#"><i class="fa fa-times"></i></a>
                                    </div> -->
                            </div>
                            <div class="tab-content mt-4" v-if="cusipId">
                                <table class="table table-striped table-hover w-100 mt-2">
                                <thead>
                                <tr>
                                    <th scope="col" class="text-left">Qty</th>
                                    <th scope="col" class="text-right">MIN</th>
                                    <th scope="col" class="text-center">PX</th>
                                    <th scope="col" class="text-center">YTM</th>
                                    <th scope="col" class="text-center">YTC</th>
                                    <th scope="col" class="text-center">YTW</th>
                                    <th scope="col" class="text-center">ACTIONS</th>
          
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="offer in offers" :key="offer.id">
                                    <td class="text-left">{{ offer.askQty }}</td>
                                    <th scope="row" class="text-right">{{ offer.minQty }}</th>
                                    <td class="text-center">{{ offer.askPx | currency }}</td>
                                    
                                    <td class="text-center">
                                        <span v-if="offer.askYtm > 16">N/A</span>
                                        <span v-else>{{ offer.askYtm }}%</span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="offer.askYtc > 16">N/A</span>
                                        <span v-else>{{ offer.askYtc }}%</span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="offer.askYtw > 16">N/A</span>
                                        <span v-else>{{ offer.askYtw }}%</span>
                                    </td>
                                     <td class="text-center">
                                        <button
                                        class="btn btn-primary"
                                        @click.stop="toggleBidModal(offer, 'BID')"
                                        >
                                        BID
                                        </button>
                                        <button
                                        type="button"
                                        class="btn btn-success"
                                        @click.stop="toggleBidModal(offer, 'BUY')"
                                        >
                                        BUY
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        <!-- MODAL -->
    <BidOrBuyModal
      v-if="isBidModalOpen"
      @close="isBidModalOpen = false"
      :selectedBid="selectedBid"
      :bidType="bidType"
    />
    </div>
</template>
<script>
import config from '@/config'
import authService from '@/authService'
import BidOrBuyModal from '@/components/client/BidOrBuyModal.vue'

export default {
    name: "MarketDepth",
    props :["cusipId", "selectedClient"],
    components: {
        BidOrBuyModal
    },
    watch: { 
    cusipId: function() { // watch it
          this.getOffers();
        }
    },
    data() {
        return {
            loading: false,
            offers: [],
            bidType: '',
            isBidModalOpen: false,
            selectedBid: null

        }
    },
    methods: {
        toggleBidModal (bid, type) {
            this.selectedBid = bid
            this.isBidModalOpen = !this.isBidModalOpen
            this.bidType = type
        },
        getOffers(){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlAutoBidder +
                    "/offering-feed/cusip-offers?cusip="+ this.cusipId+"&userId=" + (this.selectedClient ? this.selectedClient.id : authService.getUser().id) + "&isForClient=true",
                    auth
                )
                .then(result => {
                    this.offers = result.data;
                    this.loading = false;
                })
            }
    },
    mounted() {

    }
}
</script>